export default "__VITE_ASSET__DvhjDCQb__"